import withEnhanceRouter from '@src/components/route/with-enhance-router';
import { observer } from 'mobx-react';
import { autobind } from 'core-decorators';

/**
 * com 作为 component 缩写
 */
export default function com(staticMethods, options = {}) {
  const { disableWithEnhanceRouter } = options;
  return TargetComponent => {
    TargetComponent = [!disableWithEnhanceRouter && withEnhanceRouter, autobind, observer].reduceRight((Component, hoc) => {
      if (typeof hoc === 'function') {
        return hoc(Component) || Component;
      }
      return Component;
    }, TargetComponent);
    return Object.assign(TargetComponent, staticMethods);
  };
}



// WEBPACK FOOTER //
// ./src/utils/com.js